import React, { FC } from 'react';
import { Transfer } from '~/types';
import { useGetByIdAndPostedAtMutation } from '~/hooks/headTransactions';
import { buildProfileLink } from '~/utils';
import { OpenButton } from '~/components/TextField';
import { HeadTransaction } from '~/types/HeadTransaction';
import { useNotify } from '~/hooks';
import { useTranslate } from 'react-admin';

interface Props {
  children: Transfer;
}
const l = (key: string): string =>
  `components.TransactionsHistory.cellComponents.HeadTransactionLink.${key}`;

const HeadTransactionLink: FC<Props> = ({ children: rowData }) => {
  const notify = useNotify();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const mutation = useGetByIdAndPostedAtMutation(
    rowData?.transactionId,
    rowData?.timestamp,
    (data: HeadTransaction) => {
      const url = buildProfileLink(undefined, data?.id, 'HEAD_TRANSACTION');
      window.open(`${window.location.origin}${url}`, '_blank');
    },
    () => {
      notify({ type: 'error', message: t('fetchErrorMessage') });
    }
  );
  const transactionId = rowData?.transactionPublicId;

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!transactionId) {
      await mutation.mutateAsync();
    } else {
      const url = buildProfileLink(undefined, transactionId, 'HEAD_TRANSACTION');
      window.open(`${window.location.origin}${url}`, '_blank');
    }
  };
  return <OpenButton onClick={handleClick} />;
};

export default HeadTransactionLink;
